import {
  FETCH_FILTER_ORDER_HISTORY,
  FETCH_FILTER_ORDER_HISTORY_SUCCEED,
  FETCH_FILTER_ORDER_HISTORY_FAILED,
  FETCH_USER_ORDER_HISTORY,
  FETCH_USER_ORDER_HISTORY_SUCCEED,
  FETCH_USER_ORDER_HISTORY_FAILED,
  FETCH_USER_OPEN_ORDER_HISTORY,
  FETCH_USER_OPEN_ORDER_HISTORY_SUCCEED,
  FETCH_USER_OPEN_ORDER_HISTORY_FAILED,
  SEARCH_ORDER_BY_ID,
  SEARCH_ORDER_BY_ID_SUCCEED,
  SEARCH_ORDER_BY_ID_FAILED,
} from './action_types';

export default {
  fetchFilterOrderHistoryAction: (params, callback) => ({
    type: FETCH_FILTER_ORDER_HISTORY,
    params,
    callback,
  }),

  fetchFilterOrderHistoryActionSucceed: (data, totalCount) => ({
    type: FETCH_FILTER_ORDER_HISTORY_SUCCEED,
    params: {
      data,
      totalCount,
    },
  }),

  fetchFilterOrderHistoryActionFailed: (err) => ({
    type: FETCH_FILTER_ORDER_HISTORY_FAILED,
    params: {
      err,
    },
  }),

  searchOrderByIDAction: (params, callback = () => {}) => ({
    type: SEARCH_ORDER_BY_ID,
    params,
    callback,
  }),

  searchOrderByIDActionSucceed: (data) => ({
    type: SEARCH_ORDER_BY_ID_SUCCEED,
    data,
  }),

  searchOrderByIDActionFailed: (err) => ({
    type: SEARCH_ORDER_BY_ID_FAILED,
    err,
  }),

  // fetchOrderHistoryAction: (params, callback) => ({
  //   type: FETCH_USER_ORDER_HISTORY,
  //   params,
  //   callback,
  // }),
  //
  // fetchOrderHistoryActionSucceed: (data, totalCount) => ({
  //   type: FETCH_USER_ORDER_HISTORY_SUCCEED,
  //   params: {
  //     data,
  //     totalCount,
  //   },
  // }),
  //
  // fetchOrderHistoryActionFailed: (err) => ({
  //   type: FETCH_USER_ORDER_HISTORY_FAILED,
  //   params: {
  //     err,
  //   },
  // }),

  fetchUserOrderHistory: (params, callback) => ({
    type: FETCH_USER_ORDER_HISTORY,
    params,
    callback,
  }),

  fetchUserOrderHistorySucceed: (data, totalCount) => ({
    type: FETCH_USER_ORDER_HISTORY_SUCCEED,
    params: {
      data,
      totalCount,
    },
  }),

  fetchUserOrderHistoryFailed: (err) => ({
    type: FETCH_USER_ORDER_HISTORY_FAILED,
    params: {
      err,
    },
  }),

  fetchUserOpenOrderHistory: (params, callback) => ({
    type: FETCH_USER_OPEN_ORDER_HISTORY,
    params,
    callback,
  }),

  fetchUserOpenOrderHistorySucceed: (data, totalCount) => ({
    type: FETCH_USER_OPEN_ORDER_HISTORY_SUCCEED,
    data,
    totalCount,
  }),

  fetchUserOpenOrderHistoryFailed: (err) => ({
    type: FETCH_USER_OPEN_ORDER_HISTORY_FAILED,
    err,
  }),
};
